<template>
	<div class="section-map primary--text">
		<v-img :src="ImageMap" style="border-radius:24px;" />
		<!-- <p class="text-h3 my-5 text-center">Легенда карты</p> -->
		<div class="px-3 px-sm-5 pt-6 d-flex justify-space-between legend">
			<ol>
				<li>Русская игрушка</li>
				<li>Береста</li>
				<li>Ямал</li>
				<li>Валенки</li>
				<li>Гобелены</li>
				<li>Гжель</li>
				<li>Паутинка</li>
				<li>Матрешкин дом</li>
				<li>Янтарь</li>
				<li>Майолика</li>
				<li>Гончарный двор</li>
				<li>Елочка (Коробейник)</li>
				<li>Ванильный крутиш</li>
				<li>Лакумы пышки</li>
				<li>Перепечи и бублики</li>
				<li>Сладкий чуррос</li>
				<li>Ларец</li>
				<li>Шапки-ушанки</li>
				<li>Я люблю Москву</li>
				<li>Ладушки Оладушки</li>
			</ol>

			<ol start="21">
				<li>Мегрельский хачапури</li>
				<li>Торнадо картофель</li>
				<li>Беляши</li>
				<li>Пончики</li>
				<li>Карачаевский пекарь</li>
				<li>Московский пончик и крутиш</li>
				<li>Дымов гриль</li>
				<li>Наковальня/Кузнецы</li>
				<li>Шашлыки</li>
				<li>Бабл - вафли</li>
				<li>Пянсе</li>
				<li>Кебаб</li>
				<li>Блины</li>
				<li>Хот дог</li>
				<li>Чай и пироги</li>
				<li>Дымов гриль</li>
				<li>Шашлыки и купаты</li>
				<li>Каштаны и кукуруза</li>
				<li>Леденцы</li>
				<li>Леденцы</li>
			</ol>

			<ol start="41">
				<li>Горячие напитки</li>
				<li>Каштаны и кукуруза</li>
				<li>Хохлома</li>
				<li>Сладкий чуррос</li>
				<li>Пончичи</li>
				<li>Русские Традиции</li>
				<li>Блины</li>
				<li>Эльбрус</li>
				<li>Ванильный крутиш</li>
				<li>Дагестанское чуду</li>
				<li>Эвенкия</li>
				<li>Осетинские пироги</li>
				<li>Гирос</li>
				<li>Теплые вещи</li>
				<li>Каштаны и кукуруза</li>
				<li>Леденцы</li>
				<li>Каштаны и кукуруза</li>
				<li>Наковальня/Кузнецы</li>
				<li>Пункт сбора подарков <br />для участников СВО</li>
			</ol>
		</div>
	</div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
	name: 'SectionMapYarmarka',
	data: () => ({
		ImageMap: require('@/assets/images/2025/map-yarmarka.jpg'),
	}),
});
</script>

<style lang="less" scoped>
.section-map {
	.legend {
		gap: 8px;

		& > div {
			flex: 1;
		}
		ol li {
			font-weight: bold;
			padding-left: 0.5rem;
		}
	};
	border-radius: 24px;
	overflow: hidden;	
}

@media (max-width: 599px) {
	.section-map {
		div {
			font-size: 12px;
		}
	}
}
</style>
